import { api } from '@/lib/api';
import type { ShootbackStatus, TailscaleGateway } from './types';

export async function getShootbackBatch(macs: string[]): Promise<ShootbackStatus[]> {
  const response = await api.post<{ shootbacks: ShootbackStatus[] }>('/v4/legacy/shootback/batch', { macs });
  return response.shootbacks || [];
}

export async function updateShootback(mac: string, enabled: boolean): Promise<void> {
  await api.put(`/v4/legacy/shootback/${mac}/${enabled}`);
}

export async function getTailscaleGateways(): Promise<TailscaleGateway[]> {
  const response = await api.get<{ gateways: TailscaleGateway[] }>('/v4/tailscale/gateways');
  return response.gateways || [];
}
